import React from 'react'
import { CursorBlink } from './CursorBlink'

interface TerminalPromptProps {
  path?: string
  command?: string
  showCursor?: boolean
}

export const TerminalPrompt: React.FC<TerminalPromptProps> = ({
  path = '~',
  command,
  showCursor = false,
}) => {
  return (
    <span style={{ fontFamily: "'JetBrains Mono', 'Courier New', monospace", fontSize: '0.9rem' }}>
      <span style={{ color: 'var(--accent-green)' }}>codetobyte@blog</span>
      <span style={{ color: 'var(--text-muted, #555)' }}>:</span>
      <span style={{ color: 'var(--accent-cyan)' }}>{path}</span>
      <span style={{ color: 'var(--text-muted, #555)' }}>$</span>
      {' '}
      {command && (
        <span style={{ color: 'var(--text-primary)' }}>{command}</span>
      )}
      {showCursor && <CursorBlink />}
    </span>
  )
}
